import { Nullable } from 'utils/tsHelpers';

interface TabbableChild {
  el: HTMLElement;
  isFocused: boolean;
}

// gets the tabable children of an element
export const getTabbableChildren = (target?: Nullable<HTMLElement>): TabbableChild[] => {
  return Array.from(target?.children ?? [])
    .filter((child): child is HTMLElement => child instanceof HTMLElement && child.tabIndex === 0)
    .map((child) => ({ el: child, isFocused: child === document.activeElement }));
};

// checks if ref contains focus within
export const refContainsFocus = ({ current }: { current: Nullable<HTMLElement> }): boolean =>
  current?.contains(document.activeElement) ?? false;
